import { DECIMAL_RE } from "@/lib/format";

const amount = (v) => {
  const s = String(v ?? "").replace(/,/g, "").trim();
  return s === "" || Number(s) === 0 ? null : s;
};

// Returns { payload } or { error } for a row draft (rule 3: Received or Spent, never both).
export function checkRow(draft) {
  if (!draft.date) return { error: "Enter a date" };
  const received = amount(draft.received);
  const spent = amount(draft.spent);
  if (received && !DECIMAL_RE.test(received)) return { error: "Received must be a number" };
  if (spent && !DECIMAL_RE.test(spent)) return { error: "Spent must be a number" };
  if (received && spent) return { error: "A row can have Received or Spent, not both" };
  if (!received && !spent) return { error: "Enter a Received or Spent amount" };
  return {
    payload: {
      date: draft.date, description: draft.description || "", received, spent,
      category: draft.category || null, notes: draft.notes || "",
      for_whom: draft.for_whom || "", what: draft.what || "", project: draft.project || "",
    },
  };
}

export const outsideFy = (date, fy) => !!(date && fy && (date < fy.start_date || date > fy.end_date));

export const cellInput =
  "h-8 w-full bg-transparent px-2 text-sm border border-transparent hover:border-border rounded-md focus:border-primary focus:outline-none transition-colors";
